import React, { useMemo } from 'react'
import styled from 'styled-components'

import { CustomerInvoiceFragment } from '../../../../../graphql/camel'
import InvoiceItemEntry from './InvoiceItemEntry'
import { InvoiceItemsPrintHeader } from './InvoiceItemsPrintHeader'

const StyledItemsContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.coolGray.cool250};
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  gap: 16px;
  @media print {
    background-color: ${({ theme }) => theme.colors.grayscale.white};
    display: table;
    border-collapse: collapse;
    width: 100%;
  }
`

export interface InvoiceContentsProps {
  className?: string
  invoice: CustomerInvoiceFragment
}

const InvoiceContents: React.FC<InvoiceContentsProps> = ({ className, invoice }) => {
  const printDiscountColumn = useMemo(() => {
    return invoice.items.some((item) => item?.discountAmount && item?.discountAmount > 0)
  }, [invoice.items])

  if (!invoice.items) {
    return <div>Invoice contents cannot be displayed at this time. Please try again later.</div>
  }

  return (
    <div className={className}>
      <h3 className="small-h3">Invoice Contents</h3>
      <StyledItemsContainer>
        <InvoiceItemsPrintHeader printDiscountColumn={printDiscountColumn} />
        {invoice.items.reduce((acc: React.ReactElement[], item) => {
          if (!item) return acc
          acc.push(
            <InvoiceItemEntry
              key={item.item}
              item={item}
              printDiscountColumn={printDiscountColumn}
            />,
          )
          return acc
        }, [])}
      </StyledItemsContainer>
    </div>
  )
}

const StyledInvoiceContents = styled(InvoiceContents)({
  marginBottom: '30px',
  paddingTop: '10px',
})

export default StyledInvoiceContents
